import { Spin } from "antd";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProjectCategories } from "../../redux/slices/general/generalAction";
import { SunburstGeneral } from "./SunburstGeneral";

export const SunBurstProject = () => {
	const {
		general: {
			projectCategories,
			loadings: { graph },
		},
	} = useSelector((state) => state);
	const dispatch = useDispatch();

	const getAllCategories = useCallback(() => {
		dispatch(getAllProjectCategories());
	}, [dispatch]);

	useEffect(() => {
		getAllCategories();
	}, [getAllCategories]);

	if (graph) {
		return (
			<>
				<div className="flex justify-center items-center sm:w-[320px] sm:h-[320px] md:w-[448px] md:h-[448px]">
					<Spin size="large" />
				</div>
			</>
		);
	} else {
		const total = projectCategories.children.reduce((acc, { children }) => {
			children.forEach(({ count }) => {
				acc += count;
			});
			return acc;
		}, 0);
		return (
			<div className="sm:w-[320px] sm:h-[320px] md:w-[448px] md:h-[448px]">
				<SunburstGeneral
					sunbursProps={{
						data: projectCategories,
						borderWidth: 0,
						cornerRadius: 0,
						id: "name",
						value: "count",
						layers: [
							"arcs",
							"arcLabels",
							({ centerX, centerY }) => (
								<text
									x={centerX}
									y={centerY}
									textAnchor="middle"
									dominantBaseline="central"
									style={{
										fontSize: "30px",
										fontWeight: 600,
									}}
								>
									{`${Number.parseFloat(total)} proyectos`}
								</text>
							),
						],
					}}
				/>
			</div>
		);
	}
};
